module.exports = __webpack_public_path__ + "static/media/tech-on-hover.bbe86252.png";